var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPass(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7128 15.6917C12.2191 15.6917 12.6295 15.2813 12.6295 14.7751C12.6295 14.2688 12.2191 13.8584 11.7128 13.8584C11.2065 13.8584 10.7961 14.2688 10.7961 14.7751C10.7961 15.2813 11.2065 15.6917 11.7128 15.6917Z",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1294 9.27515H5.2961C4.28358 9.27515 3.46277 10.096 3.46277 11.1085V18.4418C3.46277 19.4543 4.28358 20.2751 5.2961 20.2751H18.1294C19.142 20.2751 19.9628 19.4543 19.9628 18.4418V11.1085C19.9628 10.096 19.142 9.27515 18.1294 9.27515Z",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12939 9.27498V6.52498C7.12939 5.30941 7.61228 4.14362 8.47182 3.28408C9.33136 2.42454 10.4972 1.94165 11.7127 1.94165C12.9283 1.94165 14.0941 2.42454 14.9536 3.28408C15.8132 4.14362 16.2961 5.30941 16.2961 6.52498V9.27498",
    stroke: "#828997",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPass);
export default __webpack_public_path__ + "static/media/pass.84979f8281c8f4122585af90a6ab2936.svg";
export { ForwardRef as ReactComponent };